import { render, staticRenderFns } from "./OfferOnBoardModal.vue?vue&type=template&id=5d5c3804&scoped=true"
import script from "./OfferOnBoardModal.vue?vue&type=script&lang=js"
export * from "./OfferOnBoardModal.vue?vue&type=script&lang=js"
import style0 from "./OfferOnBoardModal.vue?vue&type=style&index=0&id=5d5c3804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c3804",
  null
  
)

export default component.exports